import React from 'react';
import IncomeStatementContainer from 'components/financials/comparative-income-statement/card/IncomeStatementContainer';
import BalanceSheetContainer from 'components/financials/balanceSheet/components/card/BalanceSheetContainer';
import { useSelectedDataLevel } from 'waypoint-hooks';

interface FinancialSectionProps {
    entityCodes: string[];
    hasBalanceSheetEnabled: boolean;
}

const FinancialSection = ({
    entityCodes,
    hasBalanceSheetEnabled,
}: FinancialSectionProps) => {
    const selectedDataLevel = useSelectedDataLevel();

    return (
        <div
            style={{
                position: 'relative',
                height: '100%',
                left: 0,
                right: 0,
                bottom: 0,
            }}
        >
            <IncomeStatementContainer
                entityCodes={entityCodes}
                isPropertyProfile={true}
                isVarianceReporting={false}
                selectedDataLevel={selectedDataLevel}
            />

            {hasBalanceSheetEnabled && (
                <BalanceSheetContainer
                    entityCodes={entityCodes}
                    isPropertyProfile={true}
                    selectedDataLevel={selectedDataLevel}
                />
            )}
        </div>
    );
};

export default FinancialSection;
